import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteModal: {
    show: false,
    title: "",
    message: "",
    itemId: null,
    actionType: null,
    isLoading: false,
  },
};

const modalSlice = createSlice({
  name: "modal",
  initialState,

  reducers: {
    showDeleteModal: (state, action) => {
      state.deleteModal = {
        show: true,
        title: action.payload.title,
        message: action.payload.message,
        itemId: action.payload.itemId,
        actionType: action.payload.actionType,
        isLoading: false,
      };
    },

    hideDeleteModal: (state) => {
      state.deleteModal.show = false;
      state.deleteModal.itemId = null;
      state.deleteModal.actionType = null;
      state.deleteModal.isLoading = false;
    },

    setDeleteModalLoading: (state, action) => {
      state.deleteModal.isLoading = action.payload;
    },
  },
});

export const { showDeleteModal, hideDeleteModal, setDeleteModalLoading } =
  modalSlice.actions;

export default modalSlice.reducer;
